import { Main } from 'components/Layout/Main'
import { AllEarnOpportunities } from 'components/StakingVaults/AllEarnOpportunities'

export const StakingVaults = () => {
  return (
    <Main p={0}>
      <AllEarnOpportunities />
    </Main>
  )
}
